import { action, makeObservable, observable } from 'mobx';

class LoadingStore {
  progress = 0;

  isGameResourceLoaded = false;

  isTranslationsLoaded = false;

  hasGameInitialState = false;

  hasJackpotInitialState = false;

  isAllResourceLoaded = false;

  constructor() {
    makeObservable(this, {
      progress: observable,
      isGameResourceLoaded: observable,
      isTranslationsLoaded: observable,
      hasGameInitialState: observable,
      isAllResourceLoaded: observable,
      hasJackpotInitialState: observable,
      setProgress: action.bound,
      simulateProgress: action.bound,
      setIsAllResourceLoaded: action.bound,
      setHasGameInitialState: action.bound,
      setIsGameResourceLoaded: action.bound,
      setIsTranslationsLoaded: action.bound,
      setHasJackpotInitialState: action.bound,
    });
  }

  setIsAllResourceLoaded(bool) {
    this.isAllResourceLoaded = bool;
  }

  async simulateProgress(newValue) {
    for (let i = this.progress; i <= newValue; i += 1) {
      this.updateProgress(i);
      // eslint-disable-next-line
      await new Promise((resolve) => setTimeout(resolve, 20));
    }
  }

  updateProgress(newValue) {
    this.setProgress(newValue);
    this.setIsAllResourceLoaded(Math.ceil(this.progress) === 100);
  }

  setProgress(progressValue) {
    this.progress = progressValue;
  }

  setIsGameResourceLoaded(bool) {
    this.isGameResourceLoaded = bool;
  }

  setIsTranslationsLoaded(bool) {
    this.simulateProgress(90);
    this.isTranslationsLoaded = bool;
  }

  setHasGameInitialState(bool) {
    this.simulateProgress(100);
    this.hasGameInitialState = bool;
  }

  setHasJackpotInitialState(bool) {
    this.hasJackpotInitialState = bool;
  }

  calculateProgress(arr) {
    return arr.reduce((acc, curr, _, self) => acc + (Number(curr) / self.length) * 100, 0);
  }
}

export const loadingStore = new LoadingStore();
